export class IntradaySummary {
  active: boolean;
  created: string;
  dailyPercentChange: number;
  dailyPercent: number;
  exp: number;
  expInCashBurning: number;
  expInProfitable: number;
  fundContribution: any;
  id: number;
  medianEV: number;
  medianMC: number;
  mtdPercentChange: number;
  portfolioId: number;
  summaryType: string;
  totalPl: number;
  valueChangeInUsd: number;
  valueInUsd: number;
  qtdPercentChange: number;
  updated: string;
  ytdPercentChange: number;
  waev: number;
  wamc: number;
  wayocCashBurning: number;
}
